const init = () => {
  const carousel = document.querySelector('.js-recommended-manga-rensai-carousel');
  const progressBar = document.querySelector('.js-recommended-manga-rensai-progress');
  const fade = document.querySelector('.js-recommended-manga-rensai-fade');
  if (!carousel || !progressBar) return;

  const update = () => {
    const max = carousel.scrollWidth - carousel.clientWidth;
    if (max <= 0) {
      progressBar.style.width = '100%';
      if (fade) fade.style.opacity = '0';
      return;
    }
    const atEnd = carousel.scrollLeft + carousel.clientWidth >= carousel.scrollWidth - 4;
    if (atEnd) {
      progressBar.style.width = '100%';
    } else {
      const ratio = carousel.scrollLeft / max;
      progressBar.style.width = `${20 + (100 - 20) * ratio}%`;
    }

    if (fade) {
      fade.style.opacity = atEnd ? '0' : '1';
    }
  };

  carousel.addEventListener('scroll', update, { passive: true });
  update();
};

export default { init };
